
export default {
  name: 'ReviewContents',
  props: {
    id: { type: Number, required: true },
    images: { type: Array, default: () => [] },
    comment: { type: String, default: null },
  },
};
